import { AxiosResponse } from "axios";
import { GeneralBalanceDTO } from "../../models/GeneralBalanceDTO";
import { axiosInstance } from "./axiosInstance";
import { ArticleDTO } from "../../models/ArticleDTO";
import { CourseTuitionDTO } from "../../models/CourseTuitionDTO";
import { ExencionesDeMatriculaDTO, VistaPreviaExencion } from "../../models/ExencionDTO";

const RESOURCE_URL_V2 = "/admin/campus/";

export class FinancesService {

	/* Eximir meses desde el Estado de Cuenta (2026-10-28): solo Supervisión de Caja del plantel y superadmin. */
	/* «Cambiar Monto» de la inscripción (2026-10-31): Caja del plantel, solo subir, con justificación. */
	cambiarMontoInscripcion = async (campusId: number, studentId: number, tuitionId: number, body: { amount: number; justification: string }) =>
		axiosInstance.post<{ tuitionId: number; before: number; after: number; invoice: string | null; text: string }>(
			`${RESOURCE_URL_V2}${campusId}/students/${studentId}/tuitions/${tuitionId}/_subscriptionAmount`, body);
	exemptionsAccess = async (campusId: number) => axiosInstance.get<{ canManage: boolean }>(`${RESOURCE_URL_V2}${campusId}/exemptions/_access`);
	exemptions = async (campusId: number, studentId: number, enrollmentId: number) =>
		axiosInstance.get<ExencionesDeMatriculaDTO>(`${RESOURCE_URL_V2}${campusId}/students/${studentId}/_exemptions?enrollmentId=${enrollmentId}`);
	exempt = async (campusId: number, studentId: number, body: { enrollmentId: number; tuitionIds: number[]; reason: string; explanation: string; previewHash?: string }) =>
		axiosInstance.post<ExencionesDeMatriculaDTO>(`${RESOURCE_URL_V2}${campusId}/students/${studentId}/_exemptions`, body);
	previewExemption = async (campusId: number, studentId: number, body: { enrollmentId: number; tuitionIds: number[]; reason: string; explanation: string }) =>
		axiosInstance.post<VistaPreviaExencion>(`${RESOURCE_URL_V2}${campusId}/students/${studentId}/_exemptions/_preview`, body);
	undoExemption = async (campusId: number, studentId: number, body: { enrollmentId: number; batch: string; note: string }) =>
		axiosInstance.post<ExencionesDeMatriculaDTO>(`${RESOURCE_URL_V2}${campusId}/students/${studentId}/_exemptions/_undo`, body);

	getStudentGeneralBalance = async (campusId: number, studentId: number): Promise<AxiosResponse<GeneralBalanceDTO>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/_generalBalance`;
		const generalBalance = await axiosInstance.get<GeneralBalanceDTO>(uri);
		return generalBalance;
	}

	getStudentCourses = async (campusId: number, studentId: number): Promise<AxiosResponse<CourseTuitionDTO[]>> => {
		let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/_courses`;
		let studentCourses = await axiosInstance.get<CourseTuitionDTO[]>(uri);
		return studentCourses;
	}

	/** Las mensualidades del alumno con su estado (canBePaid dice cuáles se pueden cobrar). */
	getStudentTuitions = async (campusId: number, studentId: number): Promise<AxiosResponse<any[]>> => {
		const uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/_tuitions`;
		return await axiosInstance.get<any[]>(uri);
	}

	getStudentArticles = async (campusId: number, studentId: number): Promise<AxiosResponse<ArticleDTO[]>> => {
		let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/_articles`;
		let studentArticles = await axiosInstance.get<ArticleDTO[]>(uri);
		return studentArticles;
	}

	getEnrollmentDetails = async (campusId: number, studentId: number, enrollmentId: number) => {
		let uri = `${RESOURCE_URL_V2}${campusId}/students/${studentId}/enrollments/${enrollmentId}/_details`;
		let tuitions = await axiosInstance.get(uri);
		return tuitions;
	}

	getOwedTuitionsByEnrollment = async (campusId: number, enrollmentId: number) => {
		let uri = `${RESOURCE_URL_V2}${campusId}/enrollments/${enrollmentId}/_tuitions`;
		let tuitions = await axiosInstance.get(uri);
		return tuitions;
	}

}